export const modeOfLearning = {
  Online: 'Online',
  FaceToFace: 'FaceToFace',
  Blended: 'Blended'
}


// WEBPACK FOOTER //
// ./src/constants/mode-of-learning.js